import React from 'react';
import { Row, Col } from '@thd-olt-component-react/grid';

const InstantCheckoutEdit = () => {
  return (
    <div className="instant-checkout">
      <div className="instant-checkout__wrapper">
        <div className="instant-checkout__box">
          <Row>
            <Col>
              <div className="instant-checkout__heading">Your Fastest Checkout</div>
            </Col>
            <Col nopadding>
              <span>
                <a href="/account/view/instantcheckout" className="u__default-link">
                  Update Instant Checkout Settings
                </a>
              </span>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export { InstantCheckoutEdit };
